// Centralized default menu coruses
const BASE_COURSES = [
    { key: 'canape', label: 'Canapes' },
    { key: 'starter', label: 'Starter' },
    { key: 'main dish', label: 'Mains' },
    { key: 'side dish', label: 'Sides' },
    { key: 'dessert', label: 'Desserts' },
    { key: 'add on', label: 'Extras' },
];

// Create default menu courses
export const createDefaultMenuCourses = () =>
    BASE_COURSES.map((course) => ({
        ...course,
        amount: 'Included',
        dishes: [],
    }));

// Get meal timing label
export const getMealTimingLabel = (timing: string) => {
    const labels = {
        morning: 'Breakfast',
        lunch: 'Lunch',
        evening: 'Dinner',
    };
    return labels[timing as keyof typeof labels] || timing;
};
